<template>
  <ul class="table__row">
    <li class="table__col flex flex-row align-center">
      <Avatar :img="user.avatar" circle="circle" size="s"></Avatar>
      <p class="table__text margin-width__5">{{ user.name }} {{ user.lastname }}</p>
    </li>
    <li class="table__col">
      <p class="table__text">{{ user.email }}</p>
    </li>
  </ul>
</template>

<script>
import InlineSocials from '@/components/InlineSocials';

export default {
  components: { InlineSocials },
  props: ['user'],
  data() {
    return {
      action: '',
      selected: '',
      selectedField: '',
      confirm: false,
      promiseInterval: '',
      optionsFields: {
        // goTo:{
        //   text: 'Перейти к команде',
        //   func: this.goToGroupUsers,
        //   icon: 'user-unknown',
        // },
        update: {
          text: 'Редактировать',
          func: this.openGroup,
          icon: 'edit'
        },
        delete: {
          text: 'Удалить',
          func: this.deleteUser,
          icon: 'delete',
          iconWidth: '10px',
          confirm: true,
          confirmTitle: 'Вы уверены, что хотите удалить из команды?',
          confirmApplyText: 'Удалить',
          confirmCancelText: 'Отменить',
          red: true
        }
      }
    };
  },
  methods: {
    async clickAction(action) {
      let result;
      this.confirm = true;
      this.selectedField = this.optionsFields[action];
      result = await new Promise((res, rej) => {
        this.promiseInterval = setInterval(() => {
          if (this.selected === 'success') {
            res('next');
          } else if (this.selected === 'cancel') {
            res('cancel');
          }
        }, 50);
      });

      this.clearConfirmData();

      if (result === 'cancel') {
        return;
      }

      this.optionsFields[action].func();
    },
    clearConfirmData() {
      this.confirm = false;
      this.selected = '';
      if (this.promiseInterval) {
        clearInterval(this.promiseInterval);
      }
    },
    openGroup() {
      this.$store.dispatch('usersTeamMembers/setAsideData', {
        path: 'user',
        value: this.user
      });
      this.$store.dispatch('usersTeamMembers/setAsideMeta', {
        path: 'isOpen',
        value: true
      });
    },
    openUser() {
      this.$store.dispatch('usersTeamMembers/setAsideData', {
        path: 'user',
        value: this.user
      });
      this.$store.dispatch('usersTeamMembers/setAsideMeta', {
        path: 'isOpen',
        value: true
      });
    },
    deleteUser() {
      this.$store.dispatch('usersTeamMembers/deleteUser', {
        user: this.user,
        groupId: this.$route.params.teamId
      });
    }
  }
};
</script>
